// css =>
import Styled from "./specificationTable.module.css";

// type =>
import { SPECIFICATION_TYPE } from "./specificationTableType";

function SpecificationTable (props: {
    specificationList: SPECIFICATION_TYPE[];
}) {
    return (
        <div className={ Styled.TableContainer }>
            <h2 className={ Styled.TableTitle }>مشخصات محصول</h2>
            
            <table className={ Styled.SpecsTable }>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'right' }}>ویژگی محصول</th>
                        <th>مقدار</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.specificationList.map((specification: SPECIFICATION_TYPE) => {
                            return (
                                <tr>
                                    <td>{ specification.specification_title }</td>
                                    <td>{ specification.specification_value }</td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        </div>
    );
}

export default SpecificationTable;
